var render, staticRenderFns
import script from "./CalMonth.vue?vue&type=script&lang=js"
export * from "./CalMonth.vue?vue&type=script&lang=js"
import style0 from "./CalMonth.vue?vue&type=style&index=0&id=5b357892&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b357892",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b357892')) {
      api.createRecord('5b357892', component.options)
    } else {
      api.reload('5b357892', component.options)
    }
    
  }
}
component.options.__file = "src/pages/systemsettings/holiday/CalMonth.vue"
export default component.exports